import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({
  selector: 'heat-map',
  templateUrl: './heat-map.component.html',
  styleUrls: ['./heat-map.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HeatMapComponent implements OnInit {
  @Input('graphData') graphData: any;

  options: any;
  constructor() { }

  ngOnInit() {
    this.options = {

      data: {
        csv: 'Date,Time,Temperature\n\
          2013-01-01,0,1.3\n\
  2013-01-01,1,1.4\n\
  2013-01-01,2,1.6\n\
  2013-01-01,3,2.0\n\
  2013-01-01,4,2.4\n\
  2013-01-01,5,2.9\n\
  2013-01-01,6,3.1\n\
  2013-01-01,7,2.8\n\
  2013-01-01,8,2.8\n\
  2013-01-01,9,2.7\n\
  2013-01-01,10,3.4\n\
  2013-01-01,11,2.6\n\
  2013-01-01,12,2.4\n\
  2013-01-01,13,2.9\n\
  2013-01-01,14,2.8\n\
  2013-01-01,15,2.8\n\
  2013-01-01,16,2.2\n\
  2013-01-01,17,1.8\n\
  2013-01-01,18,1.7\n\
  2013-01-01,19,1.8\n\
  2013-01-01,20,1.8\n\
  2013-01-01,21,1.7\n\
  2013-01-01,22,1.7\n\
  2013-01-01,23,2.2\n\
  2013-01-02,0,2.2\n\
  2013-01-02,1,2.1\n\
  2013-01-02,2,1.9\n\
  2013-01-02,3,2.0\n\
  2013-01-02,4,2.0\n\
  2013-01-02,5,2.0\n\
  2013-01-02,6,2.2\n\
  2013-01-02,7,2.3\n\
  2013-01-02,8,2.7\n\
  2013-01-02,9,2.9\n\
  2013-01-02,10,2.7\n\
  2013-01-02,11,2.7\n\
  2013-01-02,12,2.6\n\
  2013-01-02,13,2.6\n\
  2013-01-02,14,2.6\n\
  2013-01-02,15,2.5\n\
  2013-01-02,16,2.6\n\
  2013-01-02,17,2.3\n\
  2013-01-02,18,2.2\n\
  2013-01-02,19,2.2\n\
  2013-01-02,20,2.1\n\
  2013-01-02,21,1.9\n\
  2013-01-02,22,1.8\n\
  2013-01-02,23,2.2\n\
  2013-01-03,0,2.2\n\
  2013-01-03,1,1.9\n\
  2013-01-03,2,1.5\n\
  2013-01-03,3,0.7\n\
  2013-01-03,4,0.7\n\
  2013-01-03,5,0.6\n\
  2013-01-03,6,0.7\n\
  2013-01-03,7,0.8\n\
  2013-01-03,8,1.3\n\
  2013-01-03,9,2.5\n\
  2013-01-03,10,4.7\n\
  2013-01-03,11,6.1\n\
  2013-01-03,12,5.7\n\
  2013-01-03,13,5.9\n\
  2013-01-03,14,6.3\n\
  2013-01-03,15,6.4\n\
  2013-01-03,16,6.4\n\
  2013-01-03,17,6.5\n\
  2013-01-03,18,6.5\n\
  2013-01-03,19,6.6\n\
  2013-01-03,20,6.0\n\
  2013-01-03,21,5.4\n\
  2013-01-03,22,4.7\n\
  2013-01-03,23,4.0\n'
      },

      chart: {
        type: 'heatmap',
        margin: [60, 10, 80, 50]
      },

      boost: {
        useGPUTranslations: true
      },

      title: {
        text: 'Highcharts heat map',
        align: 'left',
        x: 40
      },

      subtitle: {
        text: 'Temperature variation by day and hour through 2013',
        align: 'left',
        x: 40
      },

      xAxis: {
        type: 'datetime',
        min: Date.UTC(2013, 0, 1),
        max: Date.UTC(2014, 0, 1),
        labels: {
          align: 'left',
          x: 5,
          y: 14,
          format: '{value:%B}' // long month
        },
        showLastLabel: false,
        tickLength: 16
      },

      yAxis: {
        title: {
          text: null
        },
        labels: {
          format: '{value}:00'
        },
        minPadding: 0,
        maxPadding: 0,
        startOnTick: false,
        endOnTick: false,
        tickPositions: [0, 6, 12, 18, 24],
        tickWidth: 1,
        min: 0,
        max: 23,
        reversed: true
      },

      colorAxis: {
        stops: [
          [0, '#3060cf'],
          [0.5, '#fffbbc'],
          [0.9, '#c4463a'],
          [1, '#c4463a']
        ],
        min: -15,
        max: 25,
        startOnTick: false,
        endOnTick: false,
        labels: {
          format: '{value}℃'
        }
      },

      series: [{
        boostThreshold: 100,
        borderWidth: 0,
        nullColor: '#EFEFEF',
        colsize: 24 * 36e5, // one day
        tooltip: {
          headerFormat: 'Temperature<br/>',
          pointFormat: '{point.x:%e %b, %Y} {point.y}:00: <b>{point.value} ℃</b>'
        },
        turboThreshold: Number.MAX_VALUE // #3404, remove after 4.0.5 release
      }]
    }
  }

}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/heat-map/heat-map.component.ts